// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background: var(--brand-primary);
  color: var(--text-on-dark);
  margin-top: auto;
  border-top: 3px solid var(--interactive);
}

.footer__inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 1.25rem 2rem;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 2.5rem;
}

.footer__brand {
  font-size: 1.25rem;
  color: var(--interactive);
  margin-bottom: 0.75rem;
  letter-spacing: 0.04em;
}

.footer__about {
  color: var(--text-on-dark);
  opacity: 0.85;
  max-width: 42ch;
}

.footer__heading {
  font-size: 0.8rem;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  color: var(--interactive);
  margin-bottom: 0.75rem;
}

.footer__list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.footer__link {
  color: var(--text-on-dark);
  transition: color var(--transition);
}

.footer__link:hover {
  color: var(--interactive);
}

.footer__link:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 3px;
  border-radius: var(--radius-sm);
}

.footer__contact {
  display: flex;
  align-items: baseline;
  gap: 0.4rem;
}

.footer__contact-name {
  font-weight: 600;
  color: var(--text-on-dark);
  opacity: 0.85;
}

.footer__muted {
  color: var(--text-on-dark);
  opacity: 0.7;
}

.footer__facebook {
  display: inline-flex;
  margin-top: 1rem;
}

.footer__bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding: 1rem 1.25rem;
  text-align: center;
  font-size: 0.85rem;
  color: var(--text-on-dark);
  opacity: 0.75;
}

@media (max-width: 960px) {
  .footer__inner {
    grid-template-columns: 1fr 1fr;
    gap: 2rem 1.5rem;
  }

  .footer__col:first-child {
    grid-column: 1 / -1;
  }
}

@media (max-width: 640px) {
  .footer__inner {
    grid-template-columns: 1fr;
    gap: 2rem;
    padding: 2rem 1.25rem 1.5rem;
    text-align: center;
  }

  .footer__col:first-child {
    grid-column: auto;
  }

  .footer__about {
    max-width: none;
    margin-inline: auto;
  }

  .footer__list {
    align-items: center;
  }

  .footer__contact {
    flex-direction: column;
    align-items: center;
    gap: 0.15rem;
  }

  .footer__bottom {
    padding: 1rem;
    font-size: 0.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,aAAa;EACb,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE;IACE,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;AACF","sourcesContent":[".footer {\n  background: var(--brand-primary);\n  color: var(--text-on-dark);\n  margin-top: auto;\n  border-top: 3px solid var(--interactive);\n}\n\n.footer__inner {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 3rem 1.25rem 2rem;\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr;\n  gap: 2.5rem;\n}\n\n.footer__brand {\n  font-size: 1.25rem;\n  color: var(--interactive);\n  margin-bottom: 0.75rem;\n  letter-spacing: 0.04em;\n}\n\n.footer__about {\n  color: var(--text-on-dark);\n  opacity: 0.85;\n  max-width: 42ch;\n}\n\n.footer__heading {\n  font-size: 0.8rem;\n  letter-spacing: 0.25em;\n  text-transform: uppercase;\n  color: var(--interactive);\n  margin-bottom: 0.75rem;\n}\n\n.footer__list {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.footer__link {\n  color: var(--text-on-dark);\n  transition: color var(--transition);\n}\n\n.footer__link:hover {\n  color: var(--interactive);\n}\n\n.footer__link:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 3px;\n  border-radius: var(--radius-sm);\n}\n\n.footer__contact {\n  display: flex;\n  align-items: baseline;\n  gap: 0.4rem;\n}\n\n.footer__contact-name {\n  font-weight: 600;\n  color: var(--text-on-dark);\n  opacity: 0.85;\n}\n\n.footer__muted {\n  color: var(--text-on-dark);\n  opacity: 0.7;\n}\n\n.footer__facebook {\n  display: inline-flex;\n  margin-top: 1rem;\n}\n\n.footer__bottom {\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  padding: 1rem 1.25rem;\n  text-align: center;\n  font-size: 0.85rem;\n  color: var(--text-on-dark);\n  opacity: 0.75;\n}\n\n@media (max-width: 960px) {\n  .footer__inner {\n    grid-template-columns: 1fr 1fr;\n    gap: 2rem 1.5rem;\n  }\n\n  .footer__col:first-child {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (max-width: 640px) {\n  .footer__inner {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n    padding: 2rem 1.25rem 1.5rem;\n    text-align: center;\n  }\n\n  .footer__col:first-child {\n    grid-column: auto;\n  }\n\n  .footer__about {\n    max-width: none;\n    margin-inline: auto;\n  }\n\n  .footer__list {\n    align-items: center;\n  }\n\n  .footer__contact {\n    flex-direction: column;\n    align-items: center;\n    gap: 0.15rem;\n  }\n\n  .footer__bottom {\n    padding: 1rem;\n    font-size: 0.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
